// Телефон директора. На него идёт рассылка WhatsApp, поэтому компания с неверным номером из
// рассылки выпадает. Те же правила проверяет сервер (services/main, helpers/companyPhone.js).
//
// Верный номер: +380 и девять цифр. В старых компаниях в одной ячейке бывает несколько номеров
// («+380985711429  +380997201262»): рассылка берёт первый подходящий, поэтому такая ячейка верна,
// если верен каждый номер в ней.
export const PHONE_HELP = "Телефон в формате +380XXXXXXXXX";

const PART = /^\+380\d{9}$/;

export const isValidPhone = (value) => {
  if (typeof value !== "string") return false;
  const parts = value.trim().split(/[\s,;]+/).filter(Boolean);
  return parts.length > 0 && parts.every((part) => PART.test(part));
};

// Что сказать человеку про поле; пустая строка, если с номером всё в порядке.
export const phoneError = (value) => {
  if (typeof value !== "string" || !value.trim()) return "Введите номер телефона директора";
  return isValidPhone(value) ? "" : PHONE_HELP;
};

// Последние девять цифр номера: «+380987979839», «0987979839» и «098 797 98 39» — один номер.
const tailOf = (part) => part.replace(/\D/g, "").slice(-9);
const tailsOf = (value) =>
  String(value || "")
    .split(/[\s,;]+/)
    .map(tailOf)
    .filter((tail) => tail.length === 9);

// Компании, у которых уже есть такой номер (кроме exceptId — той, что редактируют). Повтор не ошибка:
// у одного директора бывает несколько компаний, но менеджер должен его увидеть.
export const companiesWithSamePhone = (value, companies, exceptId) => {
  const tails = new Set(tailsOf(value));
  if (tails.size === 0 || !Array.isArray(companies)) return [];
  return companies.filter(
    (company) => company.id !== exceptId && tailsOf(company.phoneNumber).some((tail) => tails.has(tail))
  );
};

// Текст предупреждения под полем; пусто, если повторов нет.
const SHOWN = 5;
export const samePhoneWarning = (value, companies, exceptId) => {
  const same = companiesWithSamePhone(value, companies, exceptId);
  if (same.length === 0) return "";
  const names = same.slice(0, SHOWN).map((company) => company.name).join(", ");
  const rest = same.length > SHOWN ? ` и ещё ${same.length - SHOWN}` : "";
  return `Этот номер уже есть у ${same.length === 1 ? "компании" : "компаний"}: ${names}${rest}. Проверьте, что это не ошибка.`;
};
